import { Spinner as Sp } from '@chakra-ui/react';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';

const Spinner = () => {
    const { device, themeStyle } = useThemeContext();
    return (
        <Sp
            pos="absolute"
            color={theme[themeStyle].tag_white}
            size="xl"
            right={device.isMobile ? '40%' : '30%'}
            bottom={'50%'}
            h={20}
            w={20}
        />
    );
};

export { Spinner };
